import { LANDING_OFFER_FROM_META_KEY } from "../constants";
import { isOfMetaOrigin } from "../utils/marketing-url-params";
import { flightsSessionStore } from "@flights/web-api-utils-universal";

export default function useStoreLandingMetaOffer(offerToken: string) {
  const isMeta = isOfMetaOrigin();
  const storedOfferToken = flightsSessionStore.get(LANDING_OFFER_FROM_META_KEY);
  if (isMeta && !storedOfferToken) {
    flightsSessionStore.set(LANDING_OFFER_FROM_META_KEY, offerToken);
  }
}
